import React from 'react'

import { Formik, Field } from 'formik'

import { ZariContext } from '_zari/context'

import { Modal, Form, Col, Button } from '_zari/core'

import * as SubFamiliasService from 'services/subFamilia.service'

import FamiliaFormGroup from '../formGroups/familias'

import { Row } from 'react-bootstrap'

const NuevaSubFamiliaModal = ({ show, handleClose, editData, tablaRef }) => {
  const __zariContext = React.useContext(ZariContext)

  const formInitialValues = React.useMemo(() => {
    return {
      nombre: editData.nombre,
      _idFamilia: editData._idFamilia
    }
  }, [editData])

  const onSubmit = React.useCallback(
    async data => {
      if (editData.nombre !== '') {
        SubFamiliasService.actualizarSubFamilia(editData.id, data).then(() => {
          __zariContext.snack('success', 'Sub Familia actualizada')
          handleClose()
        })
        tablaRef.current.reload()
      } else {
        SubFamiliasService.insertarSubFamilia(data).then(() => {
          __zariContext.snack('success', 'Sub Familia creada.')
          handleClose()
        })
        tablaRef.current.reload()
      }
    },
    [__zariContext, editData, handleClose, tablaRef]
  )

  return (
    <Modal show={show} size='sm'>
      <Modal.Header>
        <Modal.Title>{editData.title}</Modal.Title>
      </Modal.Header>
      <Formik initialValues={formInitialValues} onSubmit={onSubmit}>
        {({ errors, touched, isSubmitting, values, setValues, handleSubmit, handleChange }) => (
          <Form>
            <Modal.Body>
              <Form.Group>
                <Row>
                  <Col sm={6} md={12}>
                    <FamiliaFormGroup
                      iError={errors.familia}
                      iTouched={touched.familia}
                      fIsSubmitting={isSubmitting}
                      values={values}
                      setValues={setValues}
                      handleChange={handleChange}
                    />
                  </Col>
                </Row>
                <Row>
                  <Form.Label text='NOMBRE' md={4} alignRightAt='md' />
                  <Col md={8}>
                    <Field name='nombre'>
                      {({ field }) => (
                        <Form.InputText {...field} isInvalid={touched.nombre && errors.nombre} disabled={isSubmitting} id='input-nombre' />
                      )}
                    </Field>
                  </Col>
                </Row>
                {touched.nombre && errors.nombre ? <Form.Feedback type='invalid'>{errors.nombre}</Form.Feedback> : null}
              </Form.Group>
            </Modal.Body>
            <Modal.Footer>
              <Button onClick={handleClose}>Cancelar</Button>
              <Button onClick={handleSubmit}>Guardar</Button>
            </Modal.Footer>
          </Form>
        )}
      </Formik>
    </Modal>
  )
}

export default React.memo(NuevaSubFamiliaModal)
